import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the isLegalMove method.
 */
export function createIsLegalMove(context: API.Context) {
  /**
   * Check whether or not a move is legal.
   */
  return function isLegalMove(move: JCE.AnyMoveType): boolean {
    const { game } = context;

    return game.getMove(move) !== null;
  };
}
